module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "graph.cea7b651.png" + "?" + Date.now();